import { ObjectErrors } from '@/lib/utils/forms'

const TASK_FIELD_NAME_MAP: Record<string, string> = {
  from_datetime: 'fromDatetime',
  to_datetime: 'toDatetime',
  non_field_errors: '_error',
}

export function mapFieldName(key: string): string {
  return TASK_FIELD_NAME_MAP[key] || key
}

export function collectErrorMessages(obj: unknown): string[] {
  if (!obj) return []

  if (Array.isArray(obj) && obj.length > 0 && typeof obj[0] === 'string') {
    return obj as string[]
  }

  if (Array.isArray(obj)) {
    return obj.flatMap(collectErrorMessages)
  }

  if (typeof obj === 'object') {
    return Object.values(obj as ObjectErrors).flatMap(collectErrorMessages)
  }

  return []
}

export function hasFieldErrors(errors: ObjectErrors): boolean {
  return Object.keys(errors).some((key) => key !== 'detail' && key !== 'message')
}

export function buildErrorSummary(errors: ObjectErrors): string {
  const allErrors = collectErrorMessages(errors)
  const uniqueErrors = [...new Set(allErrors)].filter(Boolean)

  if (uniqueErrors.length === 0) {
    return 'Please correct the errors below and try again.'
  }

  if (uniqueErrors.length === 1) {
    return uniqueErrors[0]
  }

  return `${uniqueErrors.length} errors found: ${uniqueErrors.join('; ')}`
}

export function getDetailError(errors: ObjectErrors): string {
  return (
    (errors.detail as string) ||
    (errors.message as string) ||
    'Failed to create task. Please try again.'
  )
}
